export default "__VITE_ASSET__C8VuTX8$__"